import { platform } from "@/platform";
import { buildPrefillUrl } from "./buildPrefillUrl";

export type DeviceAttachment = { device: string; os: string; appVersion: string };

/** 고객센터 폼 자동 첨부 값(기기 모델·OS·앱 버전). 앱 버전은 빌드 번호가 있으면 "1.0.0 (7)". */
export async function readDeviceAttachment(): Promise<DeviceAttachment> {
  const [d, a] = await Promise.all([platform.device.getInfo(), platform.app.getInfo()]);
  return { device: d.model, os: d.os, appVersion: a.build !== null ? `${a.version} (${a.build})` : a.version };
}

/** 고객센터 구글 폼을 회원번호·기기 정보를 채워 연다. 채팅방 "의견 보내기"(F04-01)도 같은 폼을 쓴다(AC0-246). */
export async function openSupportForm(userId: string | null): Promise<void> {
  const attached = await readDeviceAttachment();
  await platform.browser.open(buildPrefillUrl({ ...(userId ? { userId } : {}), ...attached }));
}
